// extracted by mini-css-extract-plugin
export var container = "ambassadors-about-module--container--b858a";
export var image = "ambassadors-about-module--image--a7b31";
export var list = "ambassadors-about-module--list--75b0c";
export var section = "ambassadors-about-module--section--9dfd4";
export var text = "ambassadors-about-module--text--388f9";